import * as AccountMetadata from './grids/account';
import * as AdExtensionAssociationMetadata from './grids/ad-extension-association';
import * as AdGroupMetadata from './grids/ad-group';
import * as AdGroupAudienceAssociationMetadata from './grids/ad-group-audience-association';
import * as AdGroupCriterionMetadata from './grids/ad-group-criterion';
import * as AdMetadata from './grids/ad';
import * as AgeAndGenderMetadata from './grids/age-and-gender';
import * as AssetLinkMetadata from './grids/asset-link';
import * as AssetWithBIDataMetadata from './grids/asset-with-bi-data';
import * as AudienceAssociationMetadata from './grids/audience-association';
import * as AutomatedExtensionMetadata from './grids/automated-extension';
import * as BudgetMetadata from './grids/budget';
import * as CallForwardingDetailMetadata from './grids/call-forwarding-detail';
import * as CampaignMetadata from './grids/campaign';
import * as CampaignCriterionMetadata from './grids/campaign-criterion';
import * as ChangeHistoryDetailReportMetadata from './grids/change-history-detail-report';
import * as DestinationUrlMetadata from './grids/destination-url';
import * as DimensionRowMetadata from './grids/dimension-row';
import * as DomainCategoryMetadata from './grids/domain-category';
import * as DsaSearchTermMetadata from './grids/dsa-search-term';
import * as DsaTargetMetadata from './grids/dsa-target';
import * as GeographicMetadata from './grids/geographic';
import * as HotelMetadata from './grids/hotel';
import * as HotelGroupMetadata from './grids/hotel-group';
import * as KeywordMetadata from './grids/keyword';
import * as NegativeAdGroupCriterionMetadata from './grids/negative-ad-group-criterion';
import * as NegativeAdGroupDsaTargetMetadata from './grids/negative-ad-group-dsa-target';
import * as NegativeCampaignCriterionMetadata from './grids/negative-campaign-criterion';
import * as NegativeCampaignDsaTargetMetadata from './grids/negative-campaign-dsa-target';
import * as PortfolioBidStrategyMetadata from './grids/portfolio-bid-strategy';
import * as ProductGroupMetadata from './grids/product-group';
import * as PublisherWebsiteMetadata from './grids/publisher-website';
import * as SearchTermMetadata from './grids/search-term';
import * as SearchTermsMetadata from './grids/search-terms';
import * as ResponsiveSearchAdInstanceMetadata from './grids/responsive-search-ad-instance';
import * as ShoppingBrandMetadata from './grids/shopping-brand';
import * as ShoppingCategoryMetadata from './grids/shopping-category';
import * as ShoppingItemIdMetadata from './grids/shopping-item-id';
import * as ShoppingProductTypeMetadata from './grids/shopping-product-type';
import * as ShoppingStoreIdMetadata from './grids/shopping-store-id';
import * as SubAccountMetadata from './grids/sub-account';
import * as TimeDateMetadata from './grids/time-date';
import * as TimeDayOfWeekMetadata from './grids/time-day-of-week';
import * as TimeHourOfDayMetadata from './grids/time-hour-of-day';
import * as TimeMonthMetadata from './grids/time-month';
import * as TimeQuarterMetadata from './grids/time-quarter';
import * as TimeWeekMetadata from './grids/time-week';
import * as TimeYearMetadata from './grids/time-year';
import * as UserLocationsMetadata from './grids/user-locations';

export default {
  Account: AccountMetadata,
  Ad: AdMetadata,
  AdExtensionAssociation: AdExtensionAssociationMetadata,
  AdGroup: AdGroupMetadata,
  AdGroupAudienceAssociation: AdGroupAudienceAssociationMetadata,
  AdGroupCriterion: AdGroupCriterionMetadata,
  'AgeAndGender ': AgeAndGenderMetadata,
  AssetLink: AssetLinkMetadata,
  AssetWithBIData: AssetWithBIDataMetadata,
  AudienceAssociation: AudienceAssociationMetadata,
  AutomatedExtension: AutomatedExtensionMetadata,
  Budget: BudgetMetadata,
  CallForwardingDetail: CallForwardingDetailMetadata,
  Campaign: CampaignMetadata,
  CampaignCriterion: CampaignCriterionMetadata,
  ChangeHistoryDetailReport: ChangeHistoryDetailReportMetadata,
  DestinationUrl: DestinationUrlMetadata,
  DimensionRow: DimensionRowMetadata,
  DomainCategory: DomainCategoryMetadata,
  DsaSearchTerm: DsaSearchTermMetadata,
  DsaTarget: DsaTargetMetadata,
  Geographic: GeographicMetadata,
  Hotel: HotelMetadata,
  HotelGroup: HotelGroupMetadata,
  Keyword: KeywordMetadata,
  NegativeAdGroupCriterion: NegativeAdGroupCriterionMetadata,
  NegativeAdGroupDsaTarget: NegativeAdGroupDsaTargetMetadata,
  NegativeCampaignCriterion: NegativeCampaignCriterionMetadata,
  NegativeCampaignDsaTarget: NegativeCampaignDsaTargetMetadata,
  PortfolioBidStrategy: PortfolioBidStrategyMetadata,
  ProductGroup: ProductGroupMetadata,
  PublisherWebsite: PublisherWebsiteMetadata,
  ResponsiveSearchAdInstance: ResponsiveSearchAdInstanceMetadata,
  SearchTerm: SearchTermMetadata,
  SearchTerms: SearchTermsMetadata,
  ShoppingBrand: ShoppingBrandMetadata,
  ShoppingCategory: ShoppingCategoryMetadata,
  ShoppingItemId: ShoppingItemIdMetadata,
  ShoppingProductType: ShoppingProductTypeMetadata,
  ShoppingStoreId: ShoppingStoreIdMetadata,
  SubAccount: SubAccountMetadata,
  TimeDate: TimeDateMetadata,
  TimeDayOfWeek: TimeDayOfWeekMetadata,
  TimeHourOfDay: TimeHourOfDayMetadata,
  TimeMonth: TimeMonthMetadata,
  TimeQuarter: TimeQuarterMetadata,
  TimeWeek: TimeWeekMetadata,
  TimeYear: TimeYearMetadata,
  UserLocations: UserLocationsMetadata,
};
